import React from "react";

import { setTooltip } from "~/lib/utils";

export function DisabledOnExternalStreamTooltip({
	children,
	showTooltip,
	workspaceName,
}: React.PropsWithChildren<{ showTooltip: boolean; workspaceName: string }>) {
	return (
		<DisabledTooltip
			children={children}
			showTooltip={showTooltip}
			tooltipContent={`You cannot do this. Only ${workspaceName} users can perform this action.`}
		/>
	);
}

export function DisabledOnStreamWithExternalUsersTooltip({
	children,
	showTooltip,
	tooltipContent,
}: React.PropsWithChildren<{ showTooltip: boolean; tooltipContent: string }>) {
	return <DisabledTooltip children={children} showTooltip={showTooltip} tooltipContent={tooltipContent} />;
}

function DisabledTooltip({
	children,
	showTooltip,
	tooltipContent,
}: React.PropsWithChildren<{ showTooltip: boolean; tooltipContent: string }>) {
	if (!showTooltip) return <>{children}</>;

	return (
		<div
			{...setTooltip(tooltipContent, {
				width: "12rem",
			})}
		>
			{children}
		</div>
	);
}
